import { render, staticRenderFns } from "./StopItemInfo.vue?vue&type=template&id=492e85d7&scoped=true&"
import script from "./StopItemInfo.vue?vue&type=script&lang=js&"
export * from "./StopItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./StopItemInfo.vue?vue&type=style&index=0&id=492e85d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e85d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492e85d7')) {
      api.createRecord('492e85d7', component.options)
    } else {
      api.reload('492e85d7', component.options)
    }
    module.hot.accept("./StopItemInfo.vue?vue&type=template&id=492e85d7&scoped=true&", function () {
      api.rerender('492e85d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/stop/helpers/StopItemInfo.vue"
export default component.exports